import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import { ContainerStyle } from '@interfaces/base';

export interface ContentProps extends PropsWithChildren, ContainerStyle {}

const Content: FC<ContentProps> = ({ children, containerStyle }) => {
  return (
    <View
      style={[
        {
          position: 'absolute',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        },
        containerStyle,
      ]}
    >
      {children}
    </View>
  );
};

export default Content;
